export const adminRoles = [
  { id: "owner", label: "Owner" },
  { id: "admin", label: "Admin" },
];
export const projectRoles = [
  { id: "estimation-eng", label: "Estimation Engineer" },
  { id: "design-eng", label: "Design Engineer" },
  { id: "purchase-eng", label: "Purchase Engineer" },
  { id: "project-eng", label: "Project Engineer" },
  { id: "project-manager", label: "Project Manager" },
];

export const allRoles = [...adminRoles, ...projectRoles];

export const userStatuses = ["active", "inactivated", "pending"];

export const projectStatuses = ["active", "inactivated", "pending"];
